import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=375fb277&scoped=true"
import script from "./VideoWrapper.vue?vue&type=script&lang=js"
export * from "./VideoWrapper.vue?vue&type=script&lang=js"
import style0 from "./VideoWrapper.vue?vue&type=style&index=0&id=375fb277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375fb277",
  null
  
)

export default component.exports